<template>
<div v-if="isLoggedIn">
  <div v-if="!isLocationSettled || isLoadingWidgetAPI">
    <!-- shimmer here -->
  </div>
  <div v-else-if="getWidgetData?.length">
    <div v-if="checkBoostAvail">
      <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
      <div v-for="(childItem, i) in getWidgetData" :key="i">
        <!-- non enrolled user -->
        <div
          v-if="
            !getUserData.isEnrolled && childItem?.props?.isEnrolled == 'false'
          "
          class="banner-widget mb32"
          @click="gotoEnroll($event)"
        >
          <img :src="childItem?.image1" class="banner-bg-img" />
          <div :style="getIconStyles(childItem?.props)" class="pr">
            <img :src="childItem?.icon" class="banner-icon" />
          </div>
          <div class="tc plr12 pr">
            <div class="banner-title fs-18 bold mt8" v-html="getTitle(childItem?.title)"></div>
            <div class="banner-sub-title fs-14 mt8" v-html="getTitle(childItem?.subTitle)"></div>
            <button class="btn bold fs-12 pt5 pb5 pr10 pl10 mt8 db-cta">
              {{childItem?.props?.ctaText}}
            </button>
          </div>
        </div>

        <!-- already enrolled user -->
        <div
          v-if="
            getUserData.isEnrolled && childItem?.props?.isEnrolled == 'true'
          "
          class="banner-widget mb32"
          @click="gotoMenu($event)"
        >
          <img :src="childItem?.image1" class="banner-bg-img" />
          <div :style="getIconStyles(childItem?.props)" class="pr">
            <img :src="childItem?.icon" class="banner-icon" />
          </div>
          <div class="tc plr12 pr">
            <div class="banner-title fs-18 bold mt8" v-html="getTitle(childItem?.title)"></div>
            <div class="banner-sub-title fs-14 mt8" v-html="getTitle(childItem?.subTitle)"></div>
            <button class="btn bold fs-12 pt5 pb5 pr10 pl10 mt8 db-cta">
              {{childItem?.props?.ctaText}}
            </button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>
</template>

<script>
import Utility from "../helpers/utility";
import { keyMapsGetter, keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import PageNames from "../config/pageNames";

import {
  staticImgBaseUrl,
  v2PwaBasePath,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";

export default {
  name: "DynamicBannerWidget",
  props: ["dataApi", "moduleProps"],
  components: {
    Observer,
  },
  data() {
    return {
      modulePropsData: {},
      widgetType: "",
      isUpdated: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.widgetType = this.modulePropsData?.type || "";
  },
  methods: {
    itisvisible() {
      if(!this.isUpdated && this.getWidgetData?.length) {
        this.eventFunction(false, { Page_Name: PageNames.NEXTGEN_HOMEPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
        this.isUpdated = true;
      }
      
    },
    getIconStyles(modProps) {
      let icoAlign = modProps?.iconPosition;
      let _ = {
        textAlign: icoAlign,
      };

      return _;
    },
    getTitle(title) {
      return Utility.getProcessedString(title, this.getUserData?.boostWeekRes);
    },
    eventFunction(isClicked = false, eObj = {}) {
      if (this.getUserData?.rewardType == "CHEESY") {
        let preEventObj = {};
        let multiplierVal = this.checkBoostAvail ? this.checkBoostAvail: '';
        if (!this.getUserData?.isEnrolled) {
          preEventObj = {
            category: "cheesy rewards",
            subCategory: "enroll now", 
            rewardsProgramme: `${multiplierVal}x Cheesy Rewards`,
            ...eObj,
          };
        } else if (this.getUserData?.isEnrolled) {
          preEventObj = {
            category: "cheesy rewards",
            subCategory: "order now",
            rewardsProgramme: `${multiplierVal}x Cheesy Rewards`,
            ...eObj,
          };  
        }

        let eventType = isClicked ? "CR_Click" : "CR_Impression";
        let userAction = isClicked ? "Click" : "Impression";
        const eventObj = Utility.amplitudeEventObj(
          userAction, 
          "2x cheesy banner", 
          "4", 
          preEventObj
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    gotoEnroll(event) {
      this.eventFunction(true, { Page_Name: PageNames.NEXTGEN_HOMEPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
      setTimeout(() => {
        window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
      }, 100);
    },
    gotoMenu() {
      this.eventFunction(true, { Page_Name: PageNames.NEXTGEN_HOMEPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
      if (this.isSeparateMenuVariant) {
        let url =
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;
      } else {
        let itmId =
          this.getBottomBarData[Object.keys(this.getBottomBarData)[0]]
            ?.categoryId;
        if (itmId) {
          Utility.scrollUptoTo("element_catg_" + itmId);
        } else {
          Utility.scrollUptoTo("pageTop");
        }
      }
    },
  },
  computed: {
    checkBoostAvail() {
      let bwObj = this.getUserData?.boostWeekRes;
      const objKey = "multiplier";

      if(this.widgetType != 'loyalty2x') {
        return true;
      } else {
        if (Utility.isKeyAvailAndObjNotEmpty(bwObj, objKey)) {
          return bwObj[objKey];
        } else {
          return false;
        }
      }
    },
    isLocationSettled() {
      let _ = this.$store.state.Location.isLocationSettled;
      return _;
    },
    isLoadingWidgetAPI() {
      return this.$store.state.User.isLoadingWidgetAPI;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    getWidgetData() {
      const {type} = this.modulePropsData
      let tempData = this.$store.state.User?.staticWidgetData;
      let key = type ? type : "";
      let data = [];
      if (key) {
        data = tempData[key] || [];
      }
      return data;
    },
    getUserData() {
      return this.$store.getters[keyMapsGetter.GET_USER_DATA];
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if(
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME ||
        Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
      ) {
        return true;
      } else {
        return false;
      }
    },
    getBottomBarData() {
      return this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEM_FOR_BOTTOMBAR];
    },
  },
};
</script>
